// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class ReplaceAlertMessage extends PFixMessage {
    get isAllowOTHTrading() {
        return this.getFieldValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING);
    }
    set isAllowOTHTrading(value) {
        if (!isNullOrUndefined(value)) {
            this.setFieldValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING, value);
        }
    }
    constructor(fieldSet) {
        super(Message.CODE_REPLACE_ALERT_MESSAGE, fieldSet);
    }
    getAlertId() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_ID);
    }
    setAlertId(alertId) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_ID, alertId);
    }
    getTradableInstrumentId() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    setTradableInstrumentId(instrumentId) {
        this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, instrumentId);
    }
    getRouteId() {
        return this.getFieldValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    setRouteId(routeId) {
        this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, routeId);
    }
    getAlertType() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_TYPE);
    }
    setAlertType(alertType) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_TYPE, alertType);
    }
    getAlertCondition() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_CONDITION);
    }
    setAlertCondition(alertCondition) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_CONDITION, alertCondition);
    }
    getAlertValue() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_VALUE);
    }
    setAlertValue(alertValue) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_VALUE, alertValue);
    }
    getAlertImportance() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_IMPORTANCE);
    }
    setAlertImportance(alertImportance) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_IMPORTANCE, alertImportance);
    }
    getAlertDate() {
        return this.getFieldValue(FieldsFactory.FIELD_DATE);
    }
    setAlertDate(alertDate) {
        this.setFieldValue(FieldsFactory.FIELD_DATE, alertDate);
    }
    getAlertAfterExecute() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_AFTER_EXECUTE);
    }
    setAlertAfterExecute(alertAfterExecute) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_AFTER_EXECUTE, alertAfterExecute);
    }
    getAlertAction() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_ACTION);
    }
    setAlertAction(alertAction) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_ACTION, alertAction);
    }
    getAlertNotification() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_NOTIFICATION);
    }
    setAlertNotification(alertNotification) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_NOTIFICATION, alertNotification);
    }
    getAlertText() {
        return this.getFieldValue(FieldsFactory.FIELD_TEXT);
    }
    setAlertText(alertText) {
        this.setFieldValue(FieldsFactory.FIELD_TEXT, alertText);
    }
    setAlertLeverage(alertLeverage) {
        this.setFieldValue(FieldsFactory.FIELD_LEVERAGE_SHORT, alertLeverage);
    }
    setAlertAccountId(accountId) {
        this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
    }
    getAlertAccountId() {
        return this.getFieldValue(FieldsFactory.FIELD_ACCOUNT_ID);
    }
}
